import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'
import { IPkSetting } from '../models/models'

export class GetPkSettingsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/pesineKontrat/getSettings',
      requesterInfo,
    })
  }

  public async getSettings(): Promise<IPkSetting> {
    return await this.getAsync<IPkSetting>()
  }
}
